// extracted by mini-css-extract-plugin
export default {"cta":"grPV_rmxq4QAf00H5LEZ","readMore":"hBY_cbbcYqcBVhKaUpCQ"};